import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  Container,
  Drawer,
  Grid,
  IconButton,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppColors } from "../../../../util/AppColors";

import {
  createConsultationRoom,
  deleteConsultationRoom,
  getConsultationRoomList,
  updateConsultationRoom,
} from "../../../../redux/reducers/consultationRoomSlice";

import CustomModal from "../../../../components/CustomModal/CustomModal";
// import CustomButton from "../../../../components/CustomButton/CustomButton";
import CustomButton from "../../../../components/CustomButton";
import CustomSwitch from "../../../../components/CustomSwitch";
import CustomTable from "../../../../components/CustomTable";
import CustomTextField from "../../../../components/CustomTextField";
import TopBar from "../../../../components/TopBar/TopBar";

const tblHdrs = [
  "sNo",
  "consultationRoom",
  "newStatus",
  "createdBy",
  "createdDate",
  "actions",
];
function ConsultationRoom() {
  const dispatch = useDispatch();

  const [search, setSearch] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [form, setForm] = useState({ ConsultationRoom: "" });
  const [editIndex, setEditIndex] = useState(null);

  const [delModVisible, setDelModVisible] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const consultationRoomState = useSelector((state) => state.consultationRoom);
  const consultationRoomList = consultationRoomState.list;

  useEffect(() => {
    dispatch(getConsultationRoomList());
  }, [dispatch]);

  const handleAddOrUpdate = () => {
    if (!form.ConsultationRoom.trim()) return;

    const payload = { name: form.ConsultationRoom };
    if (editIndex !== null) {
      const room = consultationRoomList[editIndex];
      dispatch(
        updateConsultationRoom({ facilityId: room.facilityId, ...payload })
      );
    } else {
      dispatch(createConsultationRoom(payload));
    }

    handleCloseDrawer();
  };

  const handleEdit = (index) => {
    const room = consultationRoomList[index];
    setForm({ ConsultationRoom: room.name });
    setEditIndex(index);
    setOpenDrawer(true);
  };

  const handleDelete = (room) => {
    setDeleteId(room.facilityId);
    setDelModVisible(true);
  };

  const handleDelModClose = () => {
    setDelModVisible(false);
    setDeleteId(null);
  };

  const handleDelConfirm = () => {
    dispatch(deleteConsultationRoom({ facilityId: deleteId }));
    handleDelModClose();
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
    setForm({ ConsultationRoom: "" });
    setEditIndex(null);
  };

  const filteredRows = consultationRoomList.filter((row) =>
    row.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleChangeSwitch = (status, room) => {
    dispatch(
      updateConsultationRoom({
        ...room,
        facilityId: room?.facilityId,
        status,
      })
    ).then((res) => {
      if (res?.payload) dispatch(getConsultationRoomList());
    });
  };

  return (
    <Box>
      {/* Top section */}
      <TopBar>
        <Container maxWidth="xl">
          <Toolbar variant="regular">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row-ali-cen">
                <div className="top-row-cen-con w100Per">
                  <div className="w30Per">
                    <CustomTextField
                      placeholder="Search"
                      name="name"
                      fullWidth
                      handleChange={(e) => setSearch(e.target.value)}
                      value={search}
                      backgroundColor={AppColors.lightBlue2}
                    />
                  </div>

                  <div className="ml20">
                    <CustomButton
                      text="Create"
                      onClick={() => setOpenDrawer(true)}
                    />
                  </div>
                </div>
              </div>
            </Grid>
          </Toolbar>
          <Typography className="font-medium fs12 gray28">
            Total Rooms: {filteredRows?.length}
          </Typography>
        </Container>
      </TopBar>

      {/* Table */}
      <CustomTable
        grey
        columns={tblHdrs}
        datas={filteredRows?.map((room, index) => ({
          sNo: index + 1,
          consultationRoom: room?.name,
          newStatus: (
            <div>
              <div>
                <CustomSwitch
                  value={room?.status}
                  onChange={(e) => handleChangeSwitch(e?.target?.value, room)}
                  greenToRed
                />
              </div>
              <div>{room?.status ? "Active" : "Under Maintenance"}</div>
            </div>
          ),
          createdBy: room?.userName || "-",
          createdDate: new Date(room.createdDate).toLocaleDateString(),
          actions: (
            <div>
              <IconButton
                color="primary"
                size="small"
                onClick={() => handleEdit(index)}
              >
                <EditIcon />
              </IconButton>
              <IconButton
                color="error"
                size="small"
                onClick={() => handleDelete(room)}
              >
                <DeleteIcon />
              </IconButton>
            </div>
          ),
        }))}
      />

      {/* Drawer */}
      <Drawer anchor="right" open={openDrawer} onClose={handleCloseDrawer}>
        <Box p={3} width={300}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6" color="primary">
              {editIndex !== null ? "Edit Room" : "Create Room"}
            </Typography>
            <IconButton onClick={handleCloseDrawer} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
          <TextField
            fullWidth
            label="Consultation Room Name"
            value={form.ConsultationRoom}
            onChange={(e) =>
              setForm({ ...form, ConsultationRoom: e.target.value })
            }
            margin="normal"
            InputLabelProps={{
              sx: {
                position: "absolute",
                top: "50%",
                left: "14px",
                transform: "translateY(-50%)",
                transition: "all 0.2s ease-out",
                "&.Mui-focused, &.MuiFormLabel-filled": {
                  top: "0px",
                  transform: "translateY(-50%) scale(0.75)",
                  transformOrigin: "top left",
                },
              },
            }}
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            onClick={handleAddOrUpdate}
          >
            {editIndex !== null ? "Update" : "Add"}
          </Button>
        </Box>
      </Drawer>

      {/* Delete Confirmation Modal */}
      <CustomModal
        open={delModVisible}
        onClose={handleDelModClose}
        header="Delete"
        modal
        modalWidth={30}
      >
        <Typography className="flex-center txt-regular fs14">
          Are you sure you want to delete this record?
        </Typography>
        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton text="Cancel" onClick={handleDelModClose} />
          </div>
          <div className="ml10">
            <CustomButton redBtn text="Confirm" onClick={handleDelConfirm} />
          </div>
        </div>
      </CustomModal>
    </Box>
  );
}

export default ConsultationRoom;
